import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ModalComponent } from 'src/app/core/components/modal/modal.component';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { CompanyListItem } from '../../models/company-list.model';
import { HttpResponse } from '@angular/common/http';
import { UserService } from '../../services/user.service';
import { LoginService } from '../../services/login.service';
import { UserListRefresh } from '../../services/user-list.refresh';
import { UINotificationService } from 'src/app/core/services/ui-notification.service';
import { NotificationType } from 'src/app/core/models/ui-notification.model';
import { EntityListRefresh } from 'src/app/core/services/entity-list.refresh';
import { PasswordConfirmValidator } from '../../forms/user-form/password-confirm.validator';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.css']
})
export class CreateUserComponent implements OnInit {

  form = new FormGroup({});
  public model: any;

  constructor(
    private userService: UserService,
    private loginService: LoginService,
    private userListRefresh: EntityListRefresh,
    private uiNotificationService: UINotificationService
  ) { }

  ngOnInit() {
    this.form.addControl('user', new FormGroup({
      name: new FormControl('', Validators.required),
      surname: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, Validators.email]),
      phone: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
      confirmPassword: new FormControl('', Validators.required)
    }, PasswordConfirmValidator.passwordMatch));
    this.form.addControl('permission', new FormControl('0'));
  }

  close(modal: ModalComponent) {
    modal.closeModal(null);
  }

  onSubmit(modal: ModalComponent) {

    if (this.form.valid) {
      let companyId = +localStorage.getItem('selectedCompany');

      this.userService.create({
        name: this.form.get('user.name').value,
        surname: this.form.get('user.surname').value,
        phone: this.form.get('user.phone').value,        
        isActive: true
      }).subscribe((user: any) => {
        this.loginService.create({
          email: this.form.get('user.email').value,
          userId: user.id,
          permissionType: this.form.get('permission').value,
          password: this.form.get('user.password').value,
          companyId: companyId,
          isSuperAdmin: false
        }).subscribe(() => {
          this.userListRefresh.refresh('user');
          this.uiNotificationService.add({
            type: NotificationType.Info,
            message: 'Uživatel byl vytvořen'
          });
          modal.closeModal(null);
        });
      });
    }
  }

  get isSuperadmin() {
    return this.loginService.isSuperadmin();
  }

  get isAdmin() {
    return this.loginService.isAdmin();
  }

}
